// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"8cf00f50","676":"9e7bb5b5","691":"0e2c8df6","895":"cad6466a","900":"032bd994"}[chunkId] + ".chunk.js";
};